<template>
    <v-chip
        v-if="favorite || blacklisted"
        :color="favorite ? '#F6B10033' : '#F8285A33'"
        :class="favorite ? 'favorite' : 'blacklisted'"
        class="mr-1 px-2"
        dark
        x-small
    >
        <span v-if="favorite">
            <v-icon class="mr-1" x-small>mdi-heart</v-icon>
            <b>Favorit</b>
        </span>
        <span v-else>
            <v-icon class="mr-1" x-small>mdi-cancel</v-icon>
            <b>Negativ Liste</b>
        </span>
    </v-chip>
</template>

<script>
export default {
    props: {
        favorite: Boolean,
        blacklisted: Boolean,
    }
}
</script>

<style scoped>
.favorite {
    color: #DFA000 !important;
    outline: 1px solid #DFA000;
}
.blacklisted {
    color: #D81A48 !important;
    outline: 1px solid #D81A48;
}
</style>